import { useId } from 'react';
import { Button } from '@/components/ui/button';

// Confirm-through gate: states the cost of proceeding, always lets the user
// proceed. Hand-rolled overlay, matching the app's existing dialogs.
interface ConfirmDialogProps {
  open: boolean;
  title: string;
  body: string;
  confirmLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmDialog({ open, title, body, confirmLabel, onConfirm, onCancel }: ConfirmDialogProps) {
  const titleId = useId();
  const bodyId = useId();
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
      onClick={onCancel}
      role="presentation"
    >
      <div
        role="alertdialog"
        aria-modal="true"
        aria-labelledby={titleId}
        aria-describedby={bodyId}
        className="w-full max-w-sm mx-4 rounded-lg border bg-background p-5 shadow-xl space-y-3"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id={titleId} className="font-semibold">{title}</h2>
        <p id={bodyId} className="text-sm text-muted-foreground">{body}</p>
        <div className="flex justify-end gap-2 pt-1">
          <Button variant="outline" size="sm" onClick={onCancel}>
            Cancel
          </Button>
          <Button size="sm" onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}
